// Invoice totals already include applied credit and recorded billing adjustments.
// Reapplying historical account_credit to today's service list can count returned
// credit twice after a cancellation. This summary is display-only.
const values = collection => Object.values(collection || {}).filter(Boolean);
const ids = collection => new Set(values(collection).filter(record => record.id != null).map(record => String(record.id)));

function moneyInCents(amount) {
  if (amount === null || amount === undefined) return null;
  const match = String(amount).match(/^(-?)(\d+)(?:\.(\d{1,2}))?$/);
  if (!match) return null;
  const cents = Number(match[2]) * 100 + Number((match[3] || '').padEnd(2, '0'));
  return Number.isSafeInteger(cents) ? (match[1] ? -cents : cents) : null;
}

export default function projectBillingSummary(project) {
  const invoices = values(project?.invoices);
  if (!invoices.length) return null; // Uninvoiced/local projects keep their service estimate.

  const packageIds = ids(project?.packages);
  const batchIds = ids(project?.virtual_staging_batches);
  const purchaseIds = ids(project?.virtual_staging_purchases);
  const belongsToProject = invoice => {
    if (invoice.invoiceable_id == null) return false;
    const owner = String(invoice.invoiceable_id);
    switch (invoice.invoiceable_type) {
      case 'Project': return project?.id != null && owner === String(project.id);
      case 'Package': return packageIds.has(owner);
      case 'VirtualStagingBatch': return batchIds.has(owner);
      case 'VirtualStagingPurchase': return purchaseIds.has(owner);
      default: return false;
    }
  };
  const scoped = invoices.filter(belongsToProject);
  const unavailable = {formatted: 'Unavailable', cents: null};
  if (!scoped.length) return unavailable;

  const seen = new Set();
  let total = 0;
  for (const invoice of scoped) {
    if (invoice.id == null) return unavailable;
    const id = String(invoice.id);
    if (seen.has(id)) continue;
    seen.add(id);
    const cents = moneyInCents(invoice.total);
    if (cents === null || !Number.isSafeInteger(total + cents)) return unavailable;
    total += cents;
  }
  return {cents: total, formatted: new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(total / 100)};
}
